<template>
  <div class="col-xs-12 npsds">
    <h5 class="col-xs-12 report-title">Most Sold Products</h5>
    <table class="table table-sm col-xs-12">
      <tr>
        <th>#</th>
        <th>Product</th>
        <th class="text-right">QTY</th>
        <th class="text-right">Total $</th>
      </tr>
      <tr v-for="(data, index) of reportData" :key="data._id.product">
        <td>{{ index + 1 }}.</td>
        <td>{{ data._id.product }}</td>
        <td class="text-right">{{ data.count }}</td>
        <td class="text-right">{{ (data.total / 100).toFixed(2) }}</td>
      </tr>
      <tr>
        <th colspan="4" class="text-right">
          <b-tooltip target="most-sold-info" triggers="hover">
            Total Most Sold Value is an average calculation to total products
            and their base prices, this doesn't take in consideration add-ons
            like extra options (additional ingredients) or enlarging sizes
            (coffee size to regular, large, etc.)
          </b-tooltip>
          <div id="most-sold-info">
            <i class="fas fa-exclamation-circle mr-2" />Total Most Sold Value
            ${{ (totalValue / 100).toFixed(2) }}
          </div>
        </th>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: "most-sold-products",
  props: ["reportData"],
  computed: {
    totalValue() {
      return this.reportData.reduce((a, b) => a + b.total, 0);
    },
  },
};
</script>

<style scoped>
.report-title {
  color: #5b7fbd;
}
</style>
